export default {
	islogin(state) {
		return state.login
	},
	showSidebar(state) {
		return state.showSidebar
	},
	userInfo(state) {
		return state.userInfo
	}
}